import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";

export interface iCheckAdminState {
    email : string;
    password : string;
    isLoading : boolean;
    response : any;
}

const initialState:iCheckAdminState = {
    email : '',
    password : '',
    isLoading : false,
    response : []
}

export const getCheckAdminAPI = createAsyncThunk(
    "GET_CHECK_ADMIN",
    async (__, { rejectWithValue }) => {
        const djangoEndpoint = getDjangoEndpoint();

        try {
            const pathParam = '/auth/checkAdmin/'
            const response = await axios.get(`${djangoEndpoint}${pathParam}`, {
                withCredentials: true,
            });
            return response.data;
        } catch (e) {
            console.error('Check Admin API 에러:', e);
            return rejectWithValue(e.response ? e.response.data : e.message);
        }
    }
)

export const checkAdminSlice = createSlice({
    name: 'checkAdmin',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getCheckAdminAPI.pending, (state) => {
            state.isLoading = true;
        })
        .addCase(getCheckAdminAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.response = action.payload;
        })
        .addCase(getCheckAdminAPI.rejected, (state, action) => {
            state.isLoading = false;
            state.email = '';
            state.password = '';
            state.response = action.payload; 
        })
    }
})

export default checkAdminSlice.reducer